import { ReactElement } from 'react';

import { Copyright } from './Copyright';
import { FooterLinks } from './FooterLinks';
import { GithubImg } from './GithubImg';
import { LinkedInImg } from './LinkedInImg';
import { TwitterImg } from './TwitterImg';
import config from '../config/index.json';

export const About = (): ReactElement => {
    const { company } = config;
    const { logo, name: companyName } = company;

    return (
        <div
            id='about'
            className='mx-auto container xl:px-20 lg:px-12 sm:px-6 px-4 py-12'
        >
            <div className='flex flex-col items-center justify-center'>
                <div><a href={'/'}><img src={logo} alt={companyName} className='w-32 h-32' /></a></div>
                <FooterLinks />
                <div className='flex items-center gap-x-8 mt-6 h-8 '>
                    <GithubImg />
                    <LinkedInImg />
                    <TwitterImg />
                </div>
                <Copyright />
            </div>
        </div>
    );
};
